import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  AbstractComponent,
  NavigationService,
  SolDebuggerComponent,
  SolDetailsComponent,
  SolErrorPageComponent,
  SolErrorPageType,
  SolLayoutComponent,
  SolLoader,
  SolLoaderComponent,
  SolNavbarComponent,
  SolOverlaysComponent,
  SolPageComponent,
  SolTopbarComponent,
} from '@sol/components';
import { AppState } from './app.state';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    SolDebuggerComponent,
    SolDetailsComponent,
    SolErrorPageComponent,
    SolLayoutComponent,
    SolLoaderComponent,
    SolNavbarComponent,
    SolOverlaysComponent,
    SolPageComponent,
    SolTopbarComponent,
  ],
  templateUrl: './app.component.html',
  host: { class: 'sol-app-shell' },
})
export class AppComponent extends AbstractComponent<AppState> {
  private readonly navigationService = inject(NavigationService);
  protected readonly activeRouteStatus$ = this.compute(state => state.activeRouteStatus);
  protected readonly SolErrorPageType = SolErrorPageType;
  protected readonly SolLoader = SolLoader;
  constructor() {
    super(AppState.of());
    this.navigationService.watch(state => this.update(current => current.withNavigation(state.activeRouteStatus)));
  }
}
